import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import BaseCardView from "../../Components/BaseCardView/BaseCardView";

const _ErrorType = [
  "Prolifc",
  "Demo",
  "Missing",
  "Unknown",
  "noConv",
  "Prolific2",
] as const;
type ErrorType = (typeof _ErrorType)[number];

const ErrorPage = () => {
  const setParams = useSearchParams()[1];
  const [errorType, setErrorType] = useState<ErrorType | undefined>();
  const setErrorTypeParams = useCallback(
    (params: URLSearchParams) => {
      const error: ErrorType | null =
        (params.get("type") as ErrorType) || errorType || null;
      switch (error) {
        case "Demo":
        case "Missing":
        case "Prolifc":
        case "noConv":
        case "Prolific2":
          setErrorType(error);
          break;
        default:
          setErrorType("Unknown");
          break;
      }
    },
    [errorType]
  );

  useEffect(() => {
    setParams((params) => {
      setErrorTypeParams(params);
      return [];
    });
  }, [setParams, setErrorTypeParams]);
  return (
    <BaseCardView
      disablePrevious
      hidePrev
      disableNext
      hideNext
      title="Error"
      bodyComponent={(body: string) => {
        if (errorType === "Demo") {
          return <span>Sorry but the link expired</span>;
        } else if (errorType === "Prolifc") {
          return <span>Sorry but the your prolific id is missing</span>;
        } else if (errorType === "noConv") {
          return <span>Sorry but something went wrong(0)</span>;
        } else if (errorType === "Prolific2") {
          return <span>You already done this experiment</span>;
        } else if (errorType !== "Unknown") {
          return (
            <span>
              Sorry but the link you use is missing some thing (
              {_ErrorType.findIndex((t) => t === errorType)})
            </span>
          );
        } else {
          return <span>Sorry Unknown error</span>;
        }
      }}
    />
  );
};
export default ErrorPage;
